import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Card, CardBody, Col } from 'reactstrap';
import { Surcharge } from '../../../models';
import { useTranslation } from '../../../translations';
import { displayName } from '../../../utils';
import { surchargeRateText, SurchargeTitle } from './utils';

interface SurchargesListItemProps {
  readonly surcharge: Surcharge;
}

export const SurchargesListItem: FC<SurchargesListItemProps> = ({ surcharge }) => {
  const history = useHistory();
  const { ts } = useTranslation();

  return (
    <>
      <Col className="mb-10 surcharge-item" id={`surcharge${surcharge.id}`} lg={5} xs={12}>
        <Card>
          <CardBody>
            <div className="float-end">
              <Button
                className="surcharge-item-view-details"
                color={surcharge.deletedAt ? 'secondary' : 'primary'}
                onClick={() => {
                  history.push(`/housekeeping/surcharges/${surcharge.id}`);
                }}
                outline
              >
                {ts('view')}
                {!surcharge.deletedAt && ' / Edit'} {ts('details')}
              </Button>
            </div>
            <h4 style={{ marginRight: '30px' }}>
              {displayName(surcharge)} <small>(ID: {surcharge.id})</small>
            </h4>
            <div>
              <SurchargeTitle surcharge={surcharge} /> {ts('common.of')}{' '}
              {surchargeRateText(surcharge)}
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col xs={12} />
    </>
  );
};
